import { useSdk } from '~/sdk';

export function usePaymentMethods() {
  const state = useLazyAsyncData(async () => {
    return await useSdk().commerce.getGateways({});
  });

  return state;
}
